export enum ProductionKeyPerformanceIndicatorEvaluationEnum {
  Good = 'good',
  Medium = 'medium',
  Poor = 'poor',
  NotCalculable = 'not_calculable',
}
